export const GET_ADDRESS_FORMAT_REQUEST = 'GET_ADDRESS_FORMAT_REQUEST';
export const GET_ADDRESS_FORMAT_OBJECT_REQUESTING =
  'GET_ADDRESS_FORMAT_OBJECT_REQUESTING';
export const GET_ADDRESS_FORMAT_SUCCESS = 'GET_ADDRESS_FORMAT_SUCCESS';
